import { FaHtml5, FaGithub, FaPhp, FaBootstrap, FaAngular, FaVuejs, FaLaravel } from "react-icons/fa";
import { SiTailwindcss, SiNextdotjs, SiFirebase } from "react-icons/si";
import { GrMysql, GrGraphQl } from "react-icons/gr";
import { MdCss } from "react-icons/md";
import { CgCPlusPlus } from "react-icons/cg";
import { DiJavascript1, DiReact, DiNodejs, DiMongodb, DiPython, DiJava } from "react-icons/di";
import  ParallaxText  from "../Parts/ParallaxText";
export default function ViewIcons() {
    return (
      <section className='section_icons'>
      
          <ParallaxText baseVelocity={-2}>
            <div className='tech'>
              <FaHtml5 className="tech-icons" style={{ color: "#E34F26" }} />
              <MdCss className="tech-icons" style={{ color: "#1572B6" }} />
              <FaBootstrap className="tech-icons" style={{ color: "#563D7C" }} />
              <SiTailwindcss className="tech-icons" style={{ color: "#38B2AC" }} />
              <DiReact className="tech-icons" style={{ color: "#61DAFB" }} />
              <FaAngular className="tech-icons" style={{ color: "#DD0031" }} />
              <FaVuejs className="tech-icons" style={{ color: "#41B883" }} />
              <SiNextdotjs className="tech-icons" style={{ color: "#000000" }} />
              <DiJavascript1 className="tech-icons" style={{ color: "#F0DB4F" }} />
            </div>
          </ParallaxText>
         
          <ParallaxText baseVelocity={2}>
            <div className='tech'>
              <CgCPlusPlus className="tech-icons" style={{ color: "#00599C" }} />
              <FaPhp className="tech-icons" style={{ color: "#777BB4" }} />
              <FaLaravel className="tech-icons" style={{ color: "#FF2D20" }} />
              <DiNodejs className="tech-icons" style={{ color: "#83CD29" }} />
              <DiPython className="tech-icons" style={{ color: "#306998" }} />
              <DiJava className="tech-icons" style={{ color: "#ED8B00" }} />
              <GrMysql className="tech-icons" style={{ color: "#4479A1" }} />
              <DiMongodb className="tech-icons" style={{ color: "#47A248" }} />
              <GrGraphQl className="tech-icons" style={{ color: "#728EAC" }} />
              <FaGithub className="tech-icons" style={{ color: "#181717" }} />
              <SiFirebase className="tech-icons" style={{ color: "#FFCA28" }} />
            </div>
          </ParallaxText>
        
        
       
      </section>
    );
  }